import React, { useContext, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { bool, func, number, string } from 'prop-types';
import Button from 'react-bootstrap/Button';

import { ToastContext } from './context/ToastContext';

function DeletePaymentMethodModalConfirmation({ userId, paymentMethodId, fetchPaymentMethods, show, handleClose }) {
    const { sendMessage } = useContext(ToastContext);
    const [loading, setLoading] = useState(false);
    
    const deletePaymentMethod = async () => {
        try {
            setLoading(true);
            const url = new URL(`/api/user/${userId}/paymentMethods/${paymentMethodId}`, process.env.APP_URL);
            const response = await fetch(url, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
            });
            const { error, success } = await response.json();
            if (error) {
                sendMessage(error, 'danger');
            }
            if (success) {
                sendMessage('Payment method deleted successfully', 'success');
                await fetchPaymentMethods();
                handleClose();
            }
        } catch (e) {
            sendMessage(e.message, 'danger');
        } finally {
            setLoading(false);
        }
    };
    
    return (
        <Modal
            show={show}
            onHide={handleClose}
            style={{ zIndex: 99999 }}
        >
            <Modal.Header
                closeButton
            >
                <Modal.Title>Delete payment method</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Are you sure you want to delete this payment method?</p>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant={'secondary'}
                    onClick={handleClose}
                    disabled={loading}
                >
                    No
                </Button>
                <Button
                    variant={'primary'}
                    onClick={deletePaymentMethod}
                    disabled={loading}
                >
                    Yes
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

DeletePaymentMethodModalConfirmation.propTypes = {
    userId: number,
    paymentMethodId: string,
    fetchPaymentMethods: func,
    show: bool,
    handleClose: func,
};

export default DeletePaymentMethodModalConfirmation;